import { all, fork } from "redux-saga/effects"
import addProduct from "./AddProduct/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import AuthSaga from "./auth/login/saga"
import ProfileSaga from "./auth/profile/saga"
//public
import AccountSaga from "./auth/register/saga"
import calendarSaga from "./calendar/saga"
import chatSaga from "./chat/saga"
import contactsSaga from "./contacts/saga"
import cryptoSaga from "./crypto/saga"
import dashboardSaasSaga from "./dashboard-saas/saga"
import dashboardSaga from "./dashboard/saga"
import ecommerceSaga from "./e-commerce/saga"
import invoiceSaga from "./invoices/saga"
import LayoutSaga from "./layout/saga"
import mailsSaga from "./mails/saga"
import projectsSaga from "./projects/saga"
import tasksSaga from "./tasks/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(ecommerceSaga),
    fork(calendarSaga),
    fork(chatSaga),
    fork(mailsSaga),
    fork(cryptoSaga),
    fork(invoiceSaga),
    fork(projectsSaga),
    fork(tasksSaga),
    fork(contactsSaga),
    fork(dashboardSaga),
    fork(dashboardSaasSaga),
    fork(addProduct),
  ])
}
